var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveMembers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07749 2.91279C8.07749 4.52165 6.7626 5.82558 5.14022 5.82558C3.51784 5.82558 2.20295 4.52165 2.20295 2.91279C2.20295 1.30393 3.51784 0 5.14022 0C6.7626 0 8.07749 1.30393 8.07749 2.91279ZM0 10.9753C0 8.73382 1.8312 6.91788 4.09152 6.91788H6.18892C8.44923 6.91788 10.2804 8.73382 10.2804 10.9753C10.2804 11.3485 9.97524 11.6512 9.5989 11.6512H0.681538C0.305201 11.6512 0 11.3485 0 10.9753Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5804 3.24892C11.363 3.02917 11.0076 3.02917 10.7879 3.24892C10.5681 3.46634 10.5681 3.82168 10.7879 4.04143L11.8866 5.14019L10.7879 6.23896C10.5681 6.45637 10.5704 6.81171 10.7879 7.03147C11.0053 7.25122 11.3606 7.25122 11.5804 7.03147L12.6791 5.93271L13.7779 7.03147C13.9953 7.25122 14.3507 7.24888 14.5704 7.03147C14.7902 6.81405 14.7902 6.45871 14.5704 6.23896L13.4716 5.14019L14.5704 4.04143C14.7902 3.82402 14.7878 3.46867 14.5704 3.24892C14.353 3.02917 13.9976 3.02917 13.7779 3.24892L12.6791 4.34768L11.5804 3.24892Z",
    fill: "#757A88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveMembers);
export default __webpack_public_path__ + "static/media/remove_members.0337d1d409ed1689ba8cbfd2ffc39542.svg";
export { ForwardRef as ReactComponent };